import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Car, CalendarDays, PlusCircle,
  LayoutDashboard, Users,
} from 'lucide-react';
import { HomeIcon, SearchIcon, UserIcon, RegisterIcon } from './NavIcons';
import { useAuth } from '../context/AuthContext';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useAuth();

  const role = user?.role;

  // Iconos de marca RedMobility (rm: true) → outline inactivo / filled activo.
  const itemsByRole = {
    provider: [
      { key: 'home',     label: t('bottomNav.home'),     Icon: HomeIcon, rm: true, path: '/' },
      { key: 'assets',   label: t('bottomNav.assets'),   Icon: Car,                path: '/provider/assets' },
      { key: 'bookings', label: t('bottomNav.bookings'), Icon: CalendarDays,       path: '/provider/bookings' },
      { key: 'publish',  label: t('bottomNav.publish'),  Icon: PlusCircle,         path: '/provider/post-asset' },
    ],
    admin: [
      { key: 'home',     label: t('bottomNav.home'),     Icon: HomeIcon, rm: true, path: '/' },
      { key: 'panel',    label: t('bottomNav.panel'),    Icon: LayoutDashboard,    path: '/admin/dashboard' },
      { key: 'bookings', label: t('bottomNav.bookings'), Icon: CalendarDays,       path: '/admin/bookings' },
      { key: 'users',    label: t('bottomNav.users'),    Icon: Users,              path: '/admin/users' },
    ],
    client: [
      { key: 'home',     label: t('bottomNav.home'),     Icon: HomeIcon,   rm: true, path: '/' },
      { key: 'explore',  label: t('bottomNav.explore'),  Icon: SearchIcon, rm: true, path: '/search' },
      { key: 'bookings', label: t('bottomNav.bookings'), Icon: CalendarDays,         path: '/client/dashboard' },
      { key: 'account',  label: t('bottomNav.account'),  Icon: UserIcon,   rm: true, path: '/client/profile' },
    ],
  };

  const items = itemsByRole[role] ?? [
    { key: 'home',    label: t('bottomNav.home'),    Icon: HomeIcon,     rm: true, path: '/' },
    { key: 'explore', label: t('bottomNav.explore'), Icon: SearchIcon,   rm: true, path: '/search' },
    { key: 'signin',  label: t('bottomNav.signIn'),  Icon: UserIcon,     rm: true, path: '/login' },
    { key: 'signup',  label: t('bottomNav.signUp'),  Icon: RegisterIcon, rm: true, path: '/register' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-stretch">
        {items.map((item) => {
          const { key, label, Icon, path } = item;
          const active = isActive(path);
          return (
            <button
              key={key}
              id={`bottom-nav-${key}`}
              onClick={() => navigate(path)}
              className="flex-1 flex flex-col items-center justify-center py-2 gap-0.5 active:opacity-75 transition-opacity"
            >
              {item.rm ? (
                <span style={{ color: active ? '#134168' : '#9CA3AF', lineHeight: 0 }}>
                  <Icon filled={active} size={24} />
                </span>
              ) : (
                <Icon
                  size={22}
                  strokeWidth={active ? 2.5 : 1.75}
                  color={active ? '#134168' : '#9CA3AF'}
                />
              )}
              <span
                className="text-xs font-medium"
                style={{ color: active ? '#134168' : '#9CA3AF' }}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
